import { useSalonManagerContext } from '@admin/components/templates/SalonManager/context'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import Select from '@blocks/Select'
import _ from 'lodash'
import React from 'react'
import Dashboard from './components/Dashboard'

export default function SalonGeneralPage() {
    const { salon } = useSalonManagerContext()

    const changeType = (option: Interfaces.Options<Attributes.Salon.Type>[0]) => {
        salon.actions.type.update(option.value)
    }

    return (
        <Grid gap="30px">
            <Flex justifyContent="space-between" alignItems="center">
                <Grid gap="10px">
                    <small>Type</small>
                    <Select 
                        id="type" 
                        name="type" 
                        height="s" 
                        maxWidth="150px" 
                        placeholder="Type" 
                        options={options} 
                        value={{ value: salon.state.type, label: _.capitalize(salon.state.type) }}
                        onChange={changeType} />
                </Grid>
            </Flex>
            <Dashboard />
        </Grid>
    )
}

const options: Interfaces.Options<Attributes.Salon.Type> = [
    { value: "future", label: "Future" },
    { value: "current", label: "Current" },
    { value: "voting", label: "Voting" },
    { value: "finished", label: "Finished" }
]